<template>
	<div class="">
		<a-radio-group v-model="radioType" button-style="solid">
			<a-radio-button value="2">
				周报表
			</a-radio-button>
			<a-radio-button value="3">
				月报表
			</a-radio-button>
			<a-radio-button value="4">
				季报表
			</a-radio-button>
			<a-radio-button value="5">
				年报表
			</a-radio-button>
			<a-radio-button value="6">
				综合报表
			</a-radio-button>
		</a-radio-group>
		<a-form layout="inline">
			<a-row :gutter="24">
				<a-col :md="5" :sm="5" v-if="radioType=='5'||radioType=='6'">
					<a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="数据类型"
						style="display: flex;align-items: center;">
						<a-radio-group v-model="typeData" :options="typeOptions" default-value="2"
							@change="onTypeChange" />
					</a-form-item>
				</a-col>
				<a-col :md="11" :sm="11">
					<a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="时间"
						style="display: flex;align-items: center;">
						<week-select @change="weekChange" v-if="radioType=='2'"></week-select>
						<month-select @change="monthChange" v-if="radioType=='3'"></month-select>
						<quarter-select @change="quarterChange" v-if="radioType=='4'"></quarter-select>
						<year-select @change="yearChange" v-if="radioType=='5'"></year-select>
						<a-range-picker v-else-if="radioType=='6'&&queryParam.dataType == 2"
							:placeholder="['开始月份', '结束月份']" format="YYYY-MM" :value="value" :mode="mode2"
							@panelChange="handlePanelChange2" @change="onallChange" />
						<year-range v-else-if="radioType=='6'&&queryParam.dataType == 3" @change="onYearRangeChange">
						</year-range>
					</a-form-item>
				</a-col>
				<a-col :md="6" :sm="6">
					<a-button style="margin-right:10px" @click="searchQuery" icon="search" type="primary" ghost>查询
					</a-button>
					<!-- <a-button type="primary" style="margin:0 10px" icon="download" @click="handleExportXls('周报表.xls')">
						导出</a-button> -->
					<a-button v-if="!colShow" @click="colShow=!colShow" icon="caret-right" type="primary" ghost>监测因子展开
					</a-button>
					<a-button v-else @click="colShow=!colShow" icon="caret-down" type="primary" ghost>监测因子收起</a-button>
				</a-col>
				<!-- <a-col :md="24" :sm="24">
					<a-radio-group v-model="selectSearch" @change="selectChange">
						<a-radio v-for="(item, index) in searchData" :key="index" :value="item.code">{{ item.name }}
						</a-radio>
					</a-radio-group>
				</a-col> -->
				<a-col :md="24" :sm="24" style="margin: 10px 0" v-if="colShow">
					<a-checkbox style="margin-right: 10px" :indeterminate="indeterminate" :checked="checkAll"
						@change="onCheckAllChange">
						全选
					</a-checkbox>
					<a-checkbox-group v-model="selectCol" name="checkboxgroup" :options="options" @change="onChange" />
				</a-col>
			</a-row>
		</a-form>
		<a-tabs default-active-key="1">
			<a-tab-pane key="1" tab="监测数据">
				<a-table id="tb" ref="table" size="middle" bordered :columns="columns" :scroll="scroll" :dataSource="dataSource"
					:pagination="false" :loading="loading"></a-table>
			</a-tab-pane>
			<a-tab-pane key="2" tab="趋势图">
				<trend ref="trend" :trendObj="trendObj"></trend>
			</a-tab-pane>
		</a-tabs>
		
	</div>
</template>

<script>
	import trend from '@/components/biChart/trend'
	import {
		GetSiteIdMixin
	} from '@/mixins/GetSiteIdMixin'
	import {
		ChangeColMixin
	} from '@/mixins/ChangeColMixin1'
	import weekSelect from '@/components/date/weekSelect'
	import monthSelect from '@/components/date/monthSelect'
	import quarterSelect from '@/components/date/quarterSelect'
	import yearSelect from '@/components/date/yearSelect'
	import yearRange from '@/components/date/yearRange'
	import moment from 'moment'
	export default {
		data() {
			return {
				queryState:true,
				trendObj:{},
				typeData: '2',
				typeOptions: [{
						label: '月均值',
						value: '2'
					},
					{
						label: '季度均值',
						value: '3'
					},
				],
				radioType: '2',
				isPagination: false,
				isReport: false,
				scroll: {
					y: 490,
				},
				siteName: '',
				siteId: 0,
				siteOnly: true,
				mode2: ['month', 'month'],
				value: []
			}
		},
		mixins: [GetSiteIdMixin, ChangeColMixin],
		components: {
			weekSelect,
			monthSelect,
			quarterSelect,
			yearSelect,
			yearRange,
			trend
		},
		watch: {
			radioType(value) {
				console.log('value', value)
				this.queryParam['type'] = value
				this.typeData = '2'
				delete this.queryParam['dataType']
				delete this.queryParam['stime']
				delete this.queryParam['etime']
				delete this.queryParam['quantum']
				switch (value) {
					case '5':
						this.queryParam['dataType'] = this.typeData
						break;
					case '6':
						delete this.queryParam['dataType']
						this.queryParam.stime = this.limitSelectDate.min.format('YYYY-MM-DD')
						this.queryParam.etime = this.limitSelectDate.max.format('YYYY-MM-DD')
						this.value = [this.limitSelectDate.min, this.limitSelectDate.max]
						this.queryParam['dataType'] = this.typeData
						break;
					default:
						break;
				}

				this.loadData()
			},
			currentSiteId(value) {
				var ids = this.getTreeCurrentId()
				console.log('ids', ids)
				this.queryParam.scope = ids[0]
				this.queryParam.scopeId = ids[1]
				this.checkAll = true
				this.indeterminate = false
				this.loadData()
				if (ids[0] == 1) {
					this.siteId = ids[1]
				}
			},
			currentSiteName(value) {
				this.siteName = value
			},
			loadNum(value){
				console.log(this.columns)
				console.log(this.options)
				console.log(this.dataSource)
			
				if(this.options.length>0){
					let legendData = []
					let xData = []
					let seriesData = []
					this.options.forEach((item,index)=>{
						legendData.push(item.label)
						let newObj={}
						newObj['name'] = item.label
						newObj['type'] = 'line'
						let arr = []
						this.dataSource.forEach((item1,index1)=>{
							if(item1.factor&&item1.factor[item.value]){
								arr.push(item1.factor[item.value].value)
							}else{
								arr.push('')
							}
						})
						newObj['data'] = arr
						seriesData.push(newObj)
					})
					this.dataSource.forEach((item,index)=>{
						xData.push(item.dataTime)
					})
					let obj ={
						legendData,
						seriesData,
						xData
					}
					this.trendObj = obj
					console.log(obj)
				}
			}
		},
		created() {
			this.limitSelectDate = {
				min: moment().startOf('day').subtract(1, 'months'),
				max: moment().endOf('day'),
			}
			this.url = '/online/report'
			this.$nextTick(() => {
				this.queryParam.order = 'asc'
			})
			this.queryParam['type'] = 2
			window.addEventListener('setItem', (e) => {
				if (e.key == 'siteType') {
					this.queryParam.st = window.sessionStorage.getItem('siteType')
				}
			})
		},
		methods: {
			weekChange(value) {
				this.queryParam.quantum = value[0] + '-' + value[1]
			},
			// 月变化
			monthChange(value) {
				this.queryParam.quantum = value
			},
			// 季度变化
			quarterChange(value) {
				this.queryParam.quantum = value[0] + '-' + value[1]
			},
			// 年变化
			yearChange(value) {
				this.queryParam.quantum = value
			},
			onTypeChange(e) {
				console.log('e', e)
				this.queryParam.dataType = e.target.value
				this.typeData = e.target.value
				this.typeOptions.forEach((item, index) => {
					if (item.value == e.target.value) {
						this.name = item.label
					}
				})
				this.$forceUpdate()
			},
			onallChange: function(date, dateString) {
				this.queryParam.stime = dateString[0]
				this.queryParam.etime = dateString[1]
			},
			handlePanelChange2(value, mode) {
				this.value = value
				this.queryParam.stime = value[0].format('YYYY-MM')
				this.queryParam.etime = value[1].format('YYYY-MM')
				this.mode2 = [mode[0] === 'date' ? 'month' : mode[0], mode[1] === 'date' ? 'month' : mode[1]]
			},
			onYearRangeChange: function(value) {
				this.queryParam.stime = value[0] + ''
				this.queryParam.etime = value[1] + ''
			}
		}
	}
</script>

<style lang="scss" scoped>
	.container {
		padding: 10px 20px 30px;
		box-sizing: border-box;
	}

	/deep/.ant-form-item-label {
		line-height: 32px;
		padding-right: 8px;
		width: auto;
	}
</style>
